export default "__VITE_ASSET__CdYQ_Bun__"